'use client';

import type { AppStore } from '@/redux/store';
import { useRef } from 'react';
import { Provider } from 'react-redux';
import { checkToken } from '@/redux/slices/userSlice';
import { store } from '@/redux/store';

type ReduxProviderProps = {
  children: React.ReactNode;
};

export function ReduxProvider({ children }: ReduxProviderProps) {
  const storeRef = useRef<AppStore | null>(null);

  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = store();

    // TODO: Move this client-only token check out of the render path.
    // It can make SSR and the first client render disagree for auth-dependent UI. set this into useEffect or useLayoutEffect to avoid this issue.
    storeRef.current.dispatch(checkToken());
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
